let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("1Bn96")).then(() => parcelRequire('bxLpT'));